<template>
    <div>
        <slot :show="show" :hide="hide" :toggle="toggle" :active="activeRefName"></slot>
    </div>
</template>

<script>
    export default {
        name: 'CollapsibleGroup',

        data() {
            return {
                activeRefName: null,
            };
        },

        computed: {
            activeRef: {
                get() {
                    return this.activeRefName && this.getRef(this.activeRefName);
                },
                set() {
                    this.activeRefName = null;
                },
            },
        },

        methods: {
            getRef(refName) {
                return this.$scopedSlots.default()[0].context.$refs[refName];
            },

            show(refName) {
                const ref = this.getRef(refName);
                if (!ref) {
                    console.warn('Invalid collapsible ref: ' + refName);
                    return;
                }

                this.hide();

                this.activeRefName = refName;
                ref.show();
            },

            hide() {
                if (this.activeRef) {
                    this.activeRef.hide();
                    this.activeRef = null;
                }
            },

            toggle(refName) {
                if (refName === this.activeRefName) {
                    this.hide();
                } else {
                    this.show(refName);
                }
            },
        },
    }
</script>
